import { handleActions } from "redux-actions";

import { RequestState } from "../../types/common";

import { Action } from "../actions";

export interface IState {
  deleteAccountStatus: RequestState;
}

const INITIAL_STATE: IState = {
  deleteAccountStatus: RequestState.IDLE,
};

type Payload = string;

const deleteAccount = (state: IState): IState => ({
  ...state,
  deleteAccountStatus: RequestState.PENDING,
});
const handleDeleteAccountFailure = (state: IState): IState => ({
  ...state,
  deleteAccountStatus: RequestState.FAILED,
});
const handleDeleteAccountSuccess = (state: IState): IState => ({
  ...state,
  deleteAccountStatus: RequestState.SUCCEEDED,
});

export default handleActions<IState, Payload>(
  {
    [Action.DELETE_ACCOUNT]: deleteAccount,
    [Action.HANDLE_DELETE_ACCOUNT_SUCCESS]: handleDeleteAccountSuccess,
    [Action.HANDLE_DELETE_ACCOUNT_FAILURE]: handleDeleteAccountFailure,
  },
  INITIAL_STATE
);
